import React, { FunctionComponent, useEffect, useRef } from 'react';
import { Overlay } from '../../shared/Overlay';
import './styles';

export type NavigationDrawerProps = {
  /**
   * Required. Whether the drawer is open or closed
   */
  isOpen: boolean;
  /**
   * Callback that's executed when the backdrop/menu button is clicked
   */
  onClose: () => void;
  /**
   * Whether the page has been scrolled (used to adjust padding)
   */
  isScrolled?: boolean;
  children?: React.ReactNode;
};

// TODO: Currently not animating in on Safari
export const NavigationDrawer: FunctionComponent<NavigationDrawerProps> = ({
  isOpen,
  onClose,
  isScrolled = false,
  children,
}) => {
  const hamburgerRef = useRef<HTMLButtonElement>(null);

  const clickOutsideHamburgerHandler = (event: Event): void => {
    const target = event.target as HTMLElement;
    const clickOnHamburger = target.closest('.sub-header__hamburger');

    !clickOnHamburger && onClose();
  };

  useEffect(() => {
    isOpen
      ? document.addEventListener('click', clickOutsideHamburgerHandler)
      : document.removeEventListener('click', clickOutsideHamburgerHandler);

    return () => {
      document.removeEventListener('click', clickOutsideHamburgerHandler);
    };
  }, [isOpen, onClose]);

  return (
    <Overlay
      canDismiss
      isOpen={isOpen}
      closeTimeoutMS={300}
      className={isScrolled ? 'navigation-drawer navigation-drawer--scrolled' : 'navigation-drawer'}
      role="dialog"
      backdropClassName="navigation-drawer-backdrop"
      onRequestClose={onClose}
      elementToFocusOnOpen={hamburgerRef}
      aria-label="Navigation"
      style={{ overlay: { zIndex: 9999999 } }}
    >
      {/* Navigation Links */}
      {children}
    </Overlay>
  );
};
